import React from 'react';

export default function MicroData({ application, photos }) {
  return (
    <div>
      <div itemType='https://schema.org/Product' itemScope>
        <meta itemProp='name' content={application.title} />
        {photos &&
          photos.map((photo) => (
            <link key={photo.id} itemProp='image' href={photo.url} />
          ))}
        {!photos && <link itemprop='image' href={application.photoURL} />}
        <meta itemProp='description' content={application.intro} />
        <div
          itemProp='aggregateRating'
          itemType='https://schema.org/AggregateRating'
          itemScope
        >
          <meta
            itemProp='reviewCount'
            content={Math.round(application.rating_user)}
          />
          <meta
            itemProp='ratingValue'
            content={Math.round(application.rating_avg * 10) / 10}
          />
        </div>
        <div itemProp='review' itemType='https://schema.org/Review' itemScope>
          <div itemProp='author' itemType='https://schema.org/Person' itemScope>
            <meta itemProp='name' content={application.author} />
          </div>
          <div
            itemProp='reviewRating'
            itemType='https://schema.org/Rating'
            itemScope
          >
            <meta itemProp='ratingValue' content={application.rating_avg} />
            <meta itemProp='bestRating' content={5} />
          </div>
        </div>
        <div itemProp='brand' itemType='https://schema.org/Brand' itemScope>
          <meta itemProp='name' content={application.title} />
        </div>
      </div>
    </div>
  );
}
